import { Component, OnInit, ViewChild  } from '@angular/core';
import { Location } from '@angular/common';
import { ViewEncapsulation } from '@angular/core';
import { NgbCarousel, NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';
import { LibraryV2DataService } from '../../../core/services/library-v2/library-v2-data.service';
import { LibraryV2Data } from '../../../core/interfaces/library-v2-data.i';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-offline-tutorial',
  templateUrl: './offline-tutorial.component.html',
  styleUrls: ['./offline-tutorial.component.scss']
})
export class OfflineTutorialComponent implements OnInit {
  tooltipText1: string;
  tooltipText2: string;
  tooltipText3: string;
  skipBtn: string;
  nextBtn: string;
  prevBtn: string;
  gotItBtn: string;
  specValueText: string;
  processorHeading: string;
  viewallspecsText: string;
  compareText: string;
  libraryV2Data: LibraryV2Data;
  constructor(private location: Location,
    private libraryV2DataService: LibraryV2DataService) { }
  @ViewChild('ngcarousel', { static: true }) ngCarousel: NgbCarousel;

  ngOnInit(): void {
    this.tooltipText1 = this.libraryV2DataService.getStaticText('tr_toolTipTextmb1');
    this.tooltipText2 = this.libraryV2DataService.getStaticText('tr_toolTipTextmb2');
    this.tooltipText3 = this.libraryV2DataService.getStaticText('tr_toolTipTextmb3');
    this.skipBtn = this.libraryV2DataService.getStaticText('tr_skipButton');
    this.prevBtn = this.libraryV2DataService.getStaticText('tr_prevButton');
    this.nextBtn = this.libraryV2DataService.getStaticText('tr_nextButton');
    this.gotItBtn = this.libraryV2DataService.getStaticText('tr_gotItButton');
    this.viewallspecsText = this.libraryV2DataService.getStaticText('tr_viewallspecs');
    this.compareText = this.libraryV2DataService.getStaticText('tr_compare');
    this.specValueText = this.libraryV2DataService.getStaticText('tr_coachmarkMemory');
    this.processorHeading = this.libraryV2DataService.getStaticText('tr_processorHeading');
  }

  slideActivate(ngbSlideEvent: NgbSlideEvent) {
  }
  
  // Move to previous slide
  getToPrev() {
    this.ngCarousel.prev();
  }

  // Move to next slide
  goToNext() {
    this.ngCarousel.next();
  }

  // Move to last accessed page
  back(): void {
    this.location.back()
  }

}



